import React, {ReactElement, useState} from 'react';
import {Checkbox, Typography} from '@customink/pigment-react';
import {Collapse, List, ListItem, SvgIcon} from '@mui/material';
import services from '../../api/remoteServices';
import BasketballIcon from '../../assets/icons/basketball.svg?com';
import EducationIcon from '../../assets/icons/education.svg?com';
import ArtIcon from '../../assets/icons/artwork.svg?com';
import CelebIcon from '../../assets/icons/person_man.svg?com';
import './index.scss';

export type CreativeRightsAgreementProps = {
  toggleChecked: () => void;
};

const CreativeRightsAgreement: React.FC<CreativeRightsAgreementProps> = ({
  toggleChecked
}: CreativeRightsAgreementProps): ReactElement => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="agreement-container">
      <div className="agreement-notice">
        <Checkbox className="agreement-checkbox" onChange={toggleChecked} />
        <Typography className="agreement-statement">
          I agree to respect creative rights, intellectual property owners, and
          Custom Ink&apos;s{' '}
          <a
            className="info-link"
            href={`${services.homePage}/help_center/content-standards#2`}
            target="_blank"
            rel="noreferrer">
            content standards
          </a>
          .
        </Typography>
        <br />
        <Typography
          className="expand-link info-link"
          onClick={() => setExpanded(prevExpand => !prevExpand)}>
          {expanded ? 'Read Less' : 'Read More'}
        </Typography>
      </div>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <div className="agreement-more">
          <Typography variant="captionRegular">
            Printing copyrighted, trademarked, or otherwise protected material
            generally requires its owner&apos;s permission. We review every
            online store for potential concerns, which may lead to delays,
            redesigns, or cancellations. Examples include the names, logos,
            mascots, or likenesses of:
          </Typography>
          <List dense>
            <ListItem>
              <SvgIcon
                className="agreement-icon"
                fontSize="small"
                alt="basketball"
                component={BasketballIcon}
              />
              <Typography variant="captionRegular">
                Professional sports teams
              </Typography>
            </ListItem>
            <ListItem>
              <SvgIcon
                className="agreement-icon"
                fontSize="small"
                alt="education"
                component={EducationIcon}
              />
              <Typography variant="captionRegular">Universities</Typography>
            </ListItem>
            <ListItem>
              <SvgIcon
                className="agreement-icon"
                fontSize="small"
                alt="artwork"
                component={ArtIcon}
              />
              <Typography variant="captionRegular">Brands</Typography>
            </ListItem>
            <ListItem>
              <SvgIcon
                className="agreement-icon"
                fontSize="small"
                alt="celebrity"
                component={CelebIcon}
              />
              <Typography variant="captionRegular">Celebrities</Typography>
            </ListItem>
          </List>
          <Typography variant="captionRegular">
            In some situations, especially for universities, we may be able to
            help you secure permission to print your design.
          </Typography>
          <br />
          <div className="contact-text">
            <Typography variant="captionRegular">
              If you have any questions about the content of your designs,
              please{' '}
              <a className="info-link" href="mailto:onlinestores@customink.com">
                contact us
              </a>{' '}
              before you launch your store.
            </Typography>
          </div>
        </div>
      </Collapse>
    </div>
  );
};

export default CreativeRightsAgreement;
